import React from 'react';
import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { clearGlobalError } from '../store/slices/uiSlice';

const BannerWrapper = styled.div<{ isVisible: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  background: linear-gradient(135deg, #b91c1c 0%, #ef4444 100%);
  color: white;
  padding: 0.85rem 2rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.25);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  transform: ${(props) => (props.isVisible ? 'translateY(0)' : 'translateY(-100%)')};
  opacity: ${(props) => (props.isVisible ? '1' : '0')};
  transition: all 0.35s ease-in-out;
`;

const BannerContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  position: relative;
`;

const BannerIcon = styled.div`
  font-size: 1.25rem;
`;

const BannerText = styled.div`
  font-size: 1rem;
  font-weight: 600;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 50%;
  right: 0.5rem;
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.18);
  border: none;
  color: white;
  font-size: 1.1rem;
  cursor: pointer;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.28);
    transform: translateY(-50%) rotate(90deg);
  }
`;

const GlobalErrorBanner: React.FC = () => {
  const dispatch = useAppDispatch();
  const { message, visible } = useAppSelector((state) => state.ui.globalError);

  if (!visible || !message) return null;

  const onClose = () => dispatch(clearGlobalError());

  return (
    <BannerWrapper isVisible={visible} role="alert" aria-live="polite">
      <BannerContent>
        <BannerIcon>⚠️</BannerIcon>
        <BannerText>{message}</BannerText>
        <CloseButton aria-label="Dismiss error" onClick={onClose}>×</CloseButton>
      </BannerContent>
    </BannerWrapper>
  );
};

export default GlobalErrorBanner;
